'use client'; // Error components must be Client Components

import React from 'react';
import ErrorComponent from '@/components/ErrorComponent';
import type { ErrorProps } from '../../../global-error';

export default function Error({ error }: ErrorProps): JSX.Element {
  return <ErrorComponent error={error} />;
}
